export default __webpack_public_path__ + "static/gatsby-icon-feaee9780adf1b50d6606c53091bd3c9.png";